import React from 'react'

export const nl2br = (text: string | null | undefined) =>
  (text &&
    text.split('\n').map((e, i) => (
      <span key={i}>
        {e}
        <br />
      </span>
    ))) ??
  ''
